import React from 'react';
import {
  AppLocalizationKey,
  TeamCompositionPayload,
  TechtimeBlock,
  TechtimeTimelineItem,
} from '~/common/types/types';
import {
  FormattedMessage,
  TeamCompositionList,
} from '~/components/common/common';
import { LecturesList, TechtimeItem } from '../components';
import { VideoCountLabel } from '../videos-count/videos-count';
import * as styles from './techtime-list.module.scss';
import { BlockKey } from '../../enums/enums';
import { getValidClasses } from '~/helpers/helpers';

type Props = {
  blocks: TechtimeBlock;
  timeline: TechtimeTimelineItem[];
  notice: AppLocalizationKey;
  videoLecturesCount: AppLocalizationKey;
  projectEnvironmentTitle: AppLocalizationKey;
  teamCompositionPayload: TeamCompositionPayload;
};

const TechtimeList: React.FC<Props> = ({
  blocks,
  timeline,
  notice,
  videoLecturesCount,
  projectEnvironmentTitle,
  teamCompositionPayload,
}) => {
  const [selectedBlock, setSelectedBlock] = React.useState<BlockKey>(
    BlockKey.LECTURES,
  );

  const handleSelectLectures = (): void => setSelectedBlock(BlockKey.LECTURES);
  const handleSelectProject = (): void => setSelectedBlock(BlockKey.PROJECT);

  return (
    <ul className={styles.list}>
      <TechtimeItem
        className={styles.listItem}
        item={blocks[BlockKey.LECTURES]}
        isSelected={selectedBlock === BlockKey.LECTURES}
        onClick={handleSelectLectures}
        additionalInfo={
          <VideoCountLabel
            count={timeline.length}
            message={videoLecturesCount}
          />
        }
      />

      <li
        className={getValidClasses(
          styles.listItem,
          selectedBlock === BlockKey.LECTURES
            ? styles.selectedListItem
            : styles.hiddenListItem,
        )}
      >
        <div className={styles.lecturesListWrapper}>
          <LecturesList items={timeline} notice={notice} />
        </div>
      </li>

      <TechtimeItem
        className={styles.listItem}
        item={blocks[BlockKey.PROJECT]}
        isSelected={selectedBlock === BlockKey.PROJECT}
        onClick={handleSelectProject}
      />

      <li
        className={getValidClasses(
          styles.listItem,
          selectedBlock === BlockKey.PROJECT
            ? styles.selectedListItem
            : styles.hiddenListItem,
        )}
      >
        <div className={styles.teamCompositionWrapper}>
          <h2 className={styles.projectTitle}>
            <FormattedMessage message={projectEnvironmentTitle} />
          </h2>
          <TeamCompositionList items={teamCompositionPayload.items} />
        </div>
      </li>
    </ul>
  );
};

export { TechtimeList };
